import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import useUser from '@/hooks/useUser';
import FavoriteShoppingListItem from '@/components/favorites/FavoriteShoppingListItem';
import { favoritePost } from '@/domains/firestore/user';
import { IShopping } from '@/@types/generated/contentful';

type ComponentProps = {
  shopping: IShopping;
};

const FavoriteShoppingListItemContainer: React.FC<ComponentProps> = ({ shopping }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useUser();
  const handleRequestUpdateFavorite = useCallback(
    async (postId: string) => {
      setLoading(true);
      try {
        if (user) {
          await favoritePost({ userId: user.uid, postId });
          await dispatch(updateUser(user.uid));
        }
      } catch {
        // noop
      } finally {
        setLoading(false);
      }
    },
    [dispatch, user]
  );

  return (
    <FavoriteShoppingListItem
      shopping={shopping}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      invalid={isLoading}
    />
  );
};

export default FavoriteShoppingListItemContainer;
